import { FormGroup } from '@angular/forms';
import { AttachmentModel } from '@models/module/fields/main';
import { ActionType, CipoTableOptions, TableRow } from '@shared/components/data-list/common';
import { EmailRecipient } from './email-recipient.model';
import { EmailDraft } from './inbox.model';

export interface EmailFolder {
  id: number;
  name: string;
  unreadCount: number;
  count: number;
  email?: string;
}

export interface TableIcon {
  iconKey: string;
  class: string;
}

export interface EmailRow extends TableRow {
  threadId: number;
  folderId: number;
  messageCount: number;
  displayName: string;
  subject: string;
  preview: string;
  dateSent: string;
  isRead: boolean;
  isImportant: boolean | TableIcon | string;
  hasAttachments: boolean | TableIcon | string;
  draftsMessage: string;
  conversationCount: string;
  updatedOn?: string;
  userNameInitial?: string;

  sender?: string;
  recipient?: string;

  selected?: boolean;
}

export type EmailActionType = ActionType<number, EmailRow>;
export type EmailTableOptions = CipoTableOptions<EmailActionType, EmailRow>;

export interface EmailListResponse {
  data: EmailRow[];
  records: number;
}

export interface EmailConversation {
  id: number;
  subject: string;
  contractId: number;
  folderId: number;
  emails: EmailMessage[];
  loading: boolean;

  expand?: boolean;
  isModal?: boolean;
  disableBtns?: boolean;
}

export interface EmailMessage {
  id: number;
  contractId: number;
  conversationId: number;
  conversationCount: number;
  draftCount: number;
  requestedFolderId: number;
  templateId?: number;
  subject: string;
  isConvo: boolean;
  isDraft: boolean;
  sender: EmailRecipient;
  to: EmailRecipient[];
  cc: EmailRecipient[];
  folder: EmailFolder;
  hasAttachments: boolean;
  folderName: string;
  userId: number;
  important: boolean;
  deleted: boolean;
  content: string;
  parentId: number;
  attachments: AttachmentModel[];
  createdOn: string;

  draft?: EmailDraft[];
  read?: boolean;
  readUsers?: string[];
  sent?: string;

  form?: FormGroup;
  loading?: boolean;
  saving?: boolean;
  localDraft?: EmailDraft;
}
export interface EmailListParams {
  folderId?: number;
  contractId: number;
  page: number;
  pageSize: number;
  isGlobalSearch?: boolean;
  searchTerm?: string;
}

export interface MoveEmailsParams {
  correspondenceIds: number[];
  destinationFolderId: number;
  currentFolderId: number;
  contractId: number;
}

export const SYSTEM_FOLDERS = {
  INBOX: -1,
  SENT: -2,
  DRAFTS: -3,
  TRASH: -4,
  ARCHIVE: -5,
  LOG: -6,
  CONTRACT_EMAIL: -7,
  UNREAD: -8,
};

export const SystemInboxFoldersOrdered = [
  SYSTEM_FOLDERS.INBOX,
  SYSTEM_FOLDERS.UNREAD,
  SYSTEM_FOLDERS.SENT,
  SYSTEM_FOLDERS.DRAFTS,
  SYSTEM_FOLDERS.TRASH,
  SYSTEM_FOLDERS.ARCHIVE,
  SYSTEM_FOLDERS.LOG,
  SYSTEM_FOLDERS.CONTRACT_EMAIL,
];

export const FOLDER_RESTRICTIONS: Record<number, { preventDelete: boolean; preventArchive: boolean }> = {
  [SYSTEM_FOLDERS.INBOX]: { preventDelete: false, preventArchive: false },
  [SYSTEM_FOLDERS.SENT]: { preventDelete: true, preventArchive: false },
  [SYSTEM_FOLDERS.DRAFTS]: { preventDelete: true, preventArchive: true },
  [SYSTEM_FOLDERS.TRASH]: { preventDelete: false, preventArchive: true },
  [SYSTEM_FOLDERS.ARCHIVE]: { preventDelete: false, preventArchive: true },
  [SYSTEM_FOLDERS.LOG]: { preventDelete: true, preventArchive: true },
  [SYSTEM_FOLDERS.CONTRACT_EMAIL]: { preventDelete: true, preventArchive: true },
  [SYSTEM_FOLDERS.UNREAD]: { preventDelete: false, preventArchive: false },
};
